/**
 * @see https://github.com/you-dont-need/You-Dont-Need-Momentjs
 * @see https://day.js.org/docs/en/display/from
 * @see https://day.js.org/docs/en/plugin/plugin
 * @see https://day.js.org/docs/en/plugin/utc
 * @see https://day.js.org/docs/en/plugin/update-locale
 * @see https://day.js.org/docs/en/plugin/advanced-format
 * @see https://day.js.org/docs/en/plugin/localized-format
 * @see https://day.js.org/docs/en/plugin/timezone
 * @see https://day.js.org/docs/en/timezone/timezone
 * @see https://day.js.org/docs/en/customization/relative-time
 * @see https://day.js.org/docs/en/manipulate/local
 */
 const dayjs = require('dayjs');
 const dayLocalTime = require('dayjs/plugin/utc');
 // const dayAdvancedFormat = require('dayjs/plugin/advancedFormat');
 const dayUpdateLocale = require('dayjs/plugin/updateLocale');
 const dayRelativeTime = require('dayjs/plugin/relativeTime');
 // const dayTimezone = require('dayjs/plugin/timezone');
 // const dayLocalizedFormat = require('dayjs/plugin/localizedFormat');
 // dayjs.extend(dayAdvancedFormat);
 dayjs.extend(dayUpdateLocale);
 dayjs.extend(dayRelativeTime);
 dayjs.extend(dayLocalTime);
 // dayjs.extend(dayTimezone);
 // dayjs.extend(dayLocalizedFormat);
 dayjs.locale('en');
 dayjs.updateLocale('en', {
     relativeTime: {
         future: 'in %s',
         past: '%s ago',
         // past: function (number, withoutSuffix, key, isFuture) {
         //     // return input === 'just now' ? input : input + ' ago';
         // },
         s: 'just now',
         m: "1 min",
         mm: "%d min",
         h: "1 hr",
         hh: "%d hrs",
         d: "1 day",
         dd: "%d days",
         M: "1 mth",
         MM: "%d mths",
         y: "1 yr",
         yy: "%d yrs"
     }
 });
 window.dayjs = dayjs;
